import { observable, action, makeObservable } from 'mobx';
import BaseFilters from './helpers/BaseFilters';

export default class StoreAlertFilters extends BaseFilters {
    skip = 0;
    limit = 25;
    sortBy = 'createdOn';
    sortDirection = 'DESC';
    filter = {
        search: '',
        archived: {
            _not_archived: true
        },
        signal: {
            alert: true
        }
    };
    activeCount = 0;

    constructor() {
        super();

        makeObservable(this, {
            skip: observable,
            limit: observable,
            sortBy: observable,
            sortDirection: observable,
            filter: observable,
            activeCount: observable,
            setActiveCount: action,
            setFilter: action
        });
    }

    //An action is any piece of code that modifies the state. The action annotation should only be used on functions that intend to modify the state
    setActiveCount(count) {
        this.activeCount = count;
    }

    setFilter(value) {
        this.filter = {
            ...this.filter,
            ...value
        };
        this.skip = 0;
    }
}
